export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/bryan-profile-large-ff945de3bf6d4031f2292afbf08538e1.jpg";